import { lazyRoute } from './lazy-route';
import { sectionChildren } from './section-index-redirect';

import type { RouteObject } from 'react-router-dom';

// /lgm/calculator
const lgmPremiumQuoter = lazyRoute(
  'calculator',
  () => import('@/features/lgm/premium-quoter/index'),
  { handle: { label: 'Premium Quoter', icon: 'RequestPage' } }
);

// /lgm/endorsements/active-endorsements
const lgmActiveEndorsements = lazyRoute(
  'active-endorsements',
  () =>
    import('@/features/lgm/endorsement-tracker/router-components').then(m => ({
      default: m.ActiveEndorsementsRouter
    })),
  { handle: { label: 'Active Endorsements' } }
);

// /lgm/endorsements/aip-sync
const lgmAIPSync = lazyRoute(
  'aip-sync',
  () =>
    import('@/features/lgm/endorsement-tracker/router-components').then(m => ({
      default: m.AipSyncRouter
    })),
  { handle: { label: 'AIP Sync' } }
);

// /lgm/endorsements
const lgmEndorsementTracker = lazyRoute(
  'endorsements',
  () =>
    import('@/features/lgm/endorsement-tracker').then(m => ({ default: m.LgmEndorsementTracker })),
  {
    handle: {
      label: 'Endorsements',
      icon: 'AssignmentInd',
      // LGM swine has no endorsement support — render the section but keep it inert.
      disabledWhen: params => params.type === 'swine'
    },
    children: sectionChildren([lgmActiveEndorsements, lgmAIPSync])
  }
);

// /lgm/overview/price-report-preferences
const lgmPriceReportPreferences = lazyRoute(
  'price-report-preferences',
  () => import('@/features/lgm/operation-overview/components/Preferences'),
  { handle: { label: 'Price Report Preferences' } }
);

// /lgm/overview
const lgmOperationOverview = lazyRoute(
  'overview',
  () => import('@/features/lgm/operation-overview'),
  {
    handle: { label: 'Operation Overview', icon: 'Dashboard' },
    children: sectionChildren([lgmPriceReportPreferences])
  }
);

// /lgm
export const lgmRoutes: RouteObject = lazyRoute(
  'lgm/:name/:type',
  () => import('@/features/lgm').then(m => ({ default: m.LgmModule })),
  { children: [lgmPremiumQuoter, lgmEndorsementTracker, lgmOperationOverview] }
);
